import { Dispatch } from 'redux';
import SETS_TYPES from './types';
import API_ROUTES from 'services/apiRoutes';
import { oathApi } from 'services/oathApi';

export const getSets =
  (query_str: string) =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(SETS_TYPES.setsStart());

    try {
      const response = await oathApi.get(API_ROUTES.GET_SETS(query_str));
      dispatch(SETS_TYPES.setsSuccess(response.data));
    } catch (error: any) {
      dispatch(SETS_TYPES.setsError(error.message));
    }
  };
